import React, { useEffect, useState } from 'react';
import API from '../services/api';
import Icon from './Icon';
import './StaffCard.css';

/**
 * Əməkdaş kartı — qəbul cədvəlində heyət övladının valideyninə
 * klikləyəndə açılır: kim olduğu, vəzifəsi, şöbəsi, əlaqə məlumatı
 * və kompleksdə oxuyan övladları.
 */
export default function StaffCard({ userId, onClose, t }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let dead = false;
    API.get('/users/' + userId + '/card')
      .then(r => { if (!dead) setData(r.data); })
      .catch(e => { if (!dead) setErr(e.response?.data?.message || 'Məlumat açıla bilmədi'); });
    return () => { dead = true; };
  }, [userId]);

  useEffect(() => {
    const h = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', h);
    return () => window.removeEventListener('keydown', h);
  }, [onClose]);

  const initials = (data?.name || '?').trim().split(/\s+/).slice(0, 2)
    .map(w => w[0]).join('').toUpperCase();

  return (
    <div className="sc-overlay" onClick={onClose}>
      <div className="sc-card" onClick={e => e.stopPropagation()}>
        <button className="sc-close" onClick={onClose} aria-label="Bağla">
          <Icon name="close" size={16} />
        </button>

        {err && <div className="sc-err">{err}</div>}
        {!data && !err && <div className="sc-loading">Yüklənir…</div>}

        {data && (
          <>
            <div className="sc-head">
              {data.avatar
                ? <img className="sc-avatar" src={data.avatar} alt={data.name} />
                : <div className="sc-avatar sc-initials">{initials}</div>}
              <div className="sc-ident">
                <div className="sc-name">{data.name}</div>
                <div className="sc-pos">{data.position || '—'}</div>
                {!data.is_active && <span className="sc-inactive">Deaktiv</span>}
              </div>
            </div>

            <div className="sc-rows">
              <div className="sc-row">
                <span className="sc-lbl">Şöbə</span>
                <span className="sc-val">{data.department_name || '—'}</span>
              </div>
            </div>

            <div className="sc-kids">
              <div className="sc-kids-title">
                Kompleksdə oxuyan övladları
                <span className="sc-kids-count">{(data.children || []).length}</span>
              </div>
              {(data.children || []).length === 0 ? (
                <div className="sc-kids-empty">Bağlanmış övlad qeydi yoxdur</div>
              ) : (
                <ul className="sc-kids-list">
                  {data.children.map(c => (
                    <li key={c.admission_id} className={c.enrollment_status === 'out' ? 'out' : ''}>
                      <span className="sc-kid-name">
                        {c.student_last_name} {c.student_first_name}
                      </span>
                      <span className="sc-kid-grade">
                        {c.grade || c.target_grade || '—'}
                      </span>
                      {c.enrollment_status === 'out' && <span className="sc-kid-out">ayrılıb</span>}
                      {!c.grade && <span className="sc-kid-pending">qeydiyyat gözləyir</span>}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
